import React from "react";
import { motion } from "framer-motion";
import { LuCircleCheck, LuSmartphone, LuShieldCheck, LuEye } from "react-icons/lu";
import "./BenefitsSection.css";

function BenefitsSection() {
  const handleScrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  return (
    <motion.div
      className="benefits"
      id="beneficios"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1 }}
    >
      <div className="content-section-title">
        <h2 className="section-title">¿Por qué elegir Conexs?</h2>
        <a onClick={() => handleScrollToSection("comienza")} className="btn btn-primary t-subtitle">
          Comenzar
        </a>
      </div>
      <div className="content-benefits">
        <motion.ul
          className="benefits-list"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: { opacity: 0, y: 20 },
            visible: { opacity: 1, y: 0, transition: { staggerChildren: 0.3 } },
          }}
        >
          <motion.li className="benefit-item">
            <div className="icon-box" style={{ backgroundColor: "#cce5ff" }}>
              <LuCircleCheck className="svg-icon" style={{ color: "#007bff" }} />
            </div>
            <strong className="section-text">Conexión</strong>
            <p className="section-text">Conexión instantánea con conductores disponibles.</p>
          </motion.li>
          <motion.li className="benefit-item">
            <div className="icon-box" style={{ backgroundColor: "#d4edda" }}>
              <LuSmartphone className="svg-icon" style={{ color: "#28a745" }} />
            </div>
            <strong className="section-text">Tecnología</strong>
            <p className="section-text">Tecnología avanzada para una gestión eficiente.</p>
          </motion.li>
        </motion.ul>
        <motion.ul
          className="benefits-list"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: { opacity: 0, y: 20 },
            visible: { opacity: 1, y: 0, transition: { staggerChildren: 0.3 } },
          }}
        >
          <motion.li className="benefit-item">
            <div className="icon-box" style={{ backgroundColor: "#fff3cd" }}>
              <LuShieldCheck className="svg-icon" style={{ color: "#ffc107" }} />
            </div>
            <strong className="section-text">Confiabilidad</strong>
            <p className="section-text">Servicios confiables y personalizados.</p>
          </motion.li>
          <motion.li className="benefit-item">
            <div className="icon-box" style={{ backgroundColor: "#f8d7da" }}>
              <LuEye className="svg-icon" style={{ color: "#dc3545" }} />
            </div>
            <strong className="section-text">Seguimiento</strong>
            <p className="section-text">Seguimiento en tiempo real y mensajería masiva.</p>
          </motion.li>
        </motion.ul>
      </div>
    </motion.div>
  );
}

export default BenefitsSection;